import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useUnit } from 'effector-react';
import { $profileFeatureStore } from '@lib/store';
import { useAccountFlow, useCurrencySymbol } from '@shared/hooks';
import { cn, FormatUtils, RoutePaths } from '@shared/utils';
import { AccountType, type AccountResponse } from '@shared/api';
import { DeleteConfirmationModal } from '../modals';
import { Button, Icon, Text } from '@shared/widgets';
import TrashIcon from '@assets/icons/trash.svg';

export interface SmallAccountProps {
  className?: string;
  account: AccountResponse;
  onRemove: (id: number) => void;
}

export const SmallAccount = (props: SmallAccountProps) => {
  const profileFeatureStore = useUnit($profileFeatureStore.store);

  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] = useState<boolean>(false);

  const symbol = useCurrencySymbol(props.account.currency);
  const accountFlow = useAccountFlow(profileFeatureStore.data?.accountFlows, props.account.id);

  if (!accountFlow?.view) return null;
  return (
    <>
      <div
        className={cn(
          'flex items-center justify-between gap-2 border-b border-b-gray-black pb-6',
          'last:mb-0 last:border-none last:pb-0',
          props.className,
        )}
      >
        <Link to={RoutePaths.account.onNavigate(props.account.id)}>
          <Text className='overflow-hidden text-ellipsis' uppercase weight='medium' size='xs' color='secondary'>
            {props.account.productName}
          </Text>
          <Text className='overflow-hidden text-ellipsis' uppercase weight='medium' size='xs' color='secondary'>
            {props.account.type === AccountType.Payment ? props.account.iban : FormatUtils.toSliceNumber(props.account.accountNumber)}
          </Text>
          <Text weight='medium' className='overflow-hidden text-ellipsis'>
            {symbol} {AccountType.Payment ? props.account.availableBalance : props.account.balance}
          </Text>
        </Link>
        <Button color='icon' onClick={() => setShowDeleteConfirmationModal(true)}>
          <Icon icon={<TrashIcon />} />
        </Button>
      </div>
      <DeleteConfirmationModal
        isOpen={showDeleteConfirmationModal}
        onClose={() => setShowDeleteConfirmationModal(false)}
        type={AccountType.Payment}
        onDelete={() => props.onRemove(props.account.id)}
      />
    </>
  );
};
